// third-party
import { TeamOutlined, TableOutlined } from '@ant-design/icons';
import { InsideFifaBackOfficePaths } from 'inside-fifa/routes/consts';
import { ALL_INSIDE_FIFA_TEAM_GROUPS } from 'inside-fifa/setup/auth';
import { FormattedMessage } from 'react-intl';

// type
import { NavItemType } from 'types/menu';

// ==============================|| INSIDE FIFA MENU ITEMS ||============================== //

const insideFifaMenuItems: NavItemType = {
    id: 'group-inside-fifa',
    title: <FormattedMessage id="inside-fifa.navigation.group-title" />,
    type: 'group',
    allowedGroups: ALL_INSIDE_FIFA_TEAM_GROUPS,
    children: [
        {
            id: 'inside-fifa-players-list',
            title: 'Players',
            type: 'item',
            url: InsideFifaBackOfficePaths.Players,
            icon: TeamOutlined,
            allowedGroups: ALL_INSIDE_FIFA_TEAM_GROUPS,
        },
        {
            id: 'inside-fifa-generic-tables',
            title: 'Generic Tables',
            type: 'collapse',
            icon: TableOutlined,
            allowedGroups: ALL_INSIDE_FIFA_TEAM_GROUPS,
            children: [
                {
                    id: 'inside-fifa-generic-tables-data',
                    title: <FormattedMessage id="inside-fifa.navigation.generic-tables.data" />,
                    type: 'item',
                    url: InsideFifaBackOfficePaths.GenericTablesData,
                    allowedGroups: ALL_INSIDE_FIFA_TEAM_GROUPS,
                },
                {
                    id: 'inside-fifa-generic-tables-configs',
                    title: <FormattedMessage id="inside-fifa.navigation.generic-tables.configs" />,
                    type: 'item',
                    url: InsideFifaBackOfficePaths.GenericTablesConfigs,
                    allowedGroups: ALL_INSIDE_FIFA_TEAM_GROUPS,
                },
            ],
        },
    ],
};

export default insideFifaMenuItems;
